import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { Spacer } from 'components/Utility'

type Props = {
  label: string
  time: string | null
}

const BusinessHourLabel: FC<Props> = (props) => {
  const { label, time } = props
  return (
    <div>
      <p className={styles.business__label}>{label}</p>
      <Spacer size={4} />
      <p className={styles.business__time}>{time ?? '休業日'}</p>
    </div>
  )
}

export default BusinessHourLabel
